import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';
import FunnelSettings from './FunnelSettings.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/funnels'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'settings_funnels_wrapper',
          meta: {
            permissions: ['administrator'],
          },
          redirect: to => {
            return { name: 'settings_funnels_index', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'settings_funnels_index',
          meta: {
            permissions: ['administrator'],
          },
          component: Index,
        },
        {
          path: ':funnelId',
          name: 'settings_funnels_show',
          meta: {
            permissions: ['administrator'],
          },
          component: FunnelSettings,
        },
      ],
    },
  ],
};
